import defaultTheme from '../defaultTheme';

export default {
  ...defaultTheme.mixins,
  gradient: (top, bottom) => `linear-gradient(180deg, ${top} 0%, ${bottom} 100%)`,
};
